import React, { Component } from "react";

import Modal from "react-modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import DeleteAnswer from "./delete_answer";

import { renderErrorMessage } from "../../../../helper/user_helper";
class ActionAnswerModal extends Component {
  state = { show: false, show_view: false, errors: "" };

  componentDidMount() {
    const self = this;
    setTimeout(function() {
      self.setState({ show: true });
    }, 100);
  }

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    var style = { top: "-400px" };
    if (this.state.show === true) {
      style = { top: "0px" };
    }
    if (this.state.show_view === true) {
      return <div />;
    }
    return (
      <Modal className="follow-views" isOpen={true}>
        <div className="follow-return" onClick={this.handleCloseView} />
        <div style={style} className="follow-view center">
          {this.renderView()}
        </div>
      </Modal>
    );
  }

  handleCloseView = event => {
    this.setState({ show: false });
    const self = this;
    setTimeout(function() {
      self.props.handleCloseView();
    }, 600);
  };

  renderView() {
    return (
      <div>
        <br />

        <button
          className="btn btn_primary btn_yaystack btn_invite"
          onClick={this.editQuestion}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
        <button className="btn btn_primary btn_yaystack btn_invite">
          <DeleteAnswer
            answer={this.props.answer}
            removeAnswer={this.props.removeAnswer}
            errorsAPI={this.errorsAPI}
            handleCloseView={this.handleCloseView}
          />
        </button>
        <br />
        {renderErrorMessage(this.state.errors)}
        <br />
      </div>
    );
  }

  editQuestion = e => {
    this.handleCloseView();
    this.props.editQuestion();
  };

  removeAnswer = answer => {
    this.handleCloseView();
    this.props.removeAnswer(answer);
  };

  errorsAPI = errors => {
    this.setState({ errors });
  };
}

export default ActionAnswerModal;



// WEBPACK FOOTER //
// ./src/components/list/interface/answer/action_modal.jsx